var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.page === "signup"
        ? _c("signup")
        : _vm.page === "signin"
        ? _c("signin")
        : _vm.page === "forgot"
        ? _c("forgot")
        : _vm.page === "reset"
        ? _c("reset-password")
        : _vm._e(),
      _vm.page !== "" &&
      _vm.page !== "signup" &&
      _vm.page != "signin" &&
      _vm.page != "forgot" &&
      _vm.page != "reset"
        ? _c("div", { staticClass: "page-account with-nav myaccount" }, [
            _c("h1", [_vm._v("My Account")]),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "nav" }, [
                _c(
                  "ul",
                  {
                    attrs: { role: "tablist", "aria-orientation": "vertical" }
                  },
                  [
                    _c("li", { attrs: { role: "presentation" } }, [
                      _c(
                        "a",
                        {
                          class: _vm.page == "profile" && "active",
                          attrs: {
                            role: "tab",
                            href: "#",
                            "aria-selected": (
                              _vm.page === "profile"
                            ).toString(),
                            "aria-controls": "profile"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setPage("profile")
                            }
                          }
                        },
                        [_vm._v("Account Information")]
                      )
                    ]),
                    _c("li", { attrs: { role: "presentation" } }, [
                      _c(
                        "a",
                        {
                          class: _vm.page == "addresses" && "active",
                          attrs: {
                            role: "tab",
                            href: "#",
                            tabindex: "-1",
                            "aria-selected": (
                              _vm.page === "addresses"
                            ).toString(),
                            "aria-controls": "addresses"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setPage("addresses")
                            }
                          }
                        },
                        [_vm._v("View Addresses")]
                      )
                    ]),
                    _c("li", { attrs: { role: "presentation" } }, [
                      _c(
                        "a",
                        {
                          class:
                            _vm.page == "notification_preferences" && "active",
                          attrs: {
                            role: "tab",
                            href: "#",
                            tabindex: "-1",
                            "aria-selected": (
                              _vm.page === "notification_preferences"
                            ).toString(),
                            "aria-controls": "notification_preferences"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setPage("notification_preferences")
                            }
                          }
                        },
                        [_vm._v("Notification Preferences")]
                      )
                    ]),
                    _c("li", { attrs: { role: "presentation" } }, [
                      _c(
                        "a",
                        {
                          class: _vm.page == "orders" && "active",
                          attrs: {
                            role: "tab",
                            href: "#",
                            tabindex: "-1",
                            "aria-selected": (_vm.page === "orders").toString(),
                            "aria-controls": "orders"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setPage("orders")
                            }
                          }
                        },
                        [_vm._v("Orders")]
                      )
                    ]),
                    _c("li", { attrs: { role: "presentation" } }, [
                      _c(
                        "a",
                        {
                          class: _vm.page == "subscriptions" && "active",
                          attrs: {
                            role: "tab",
                            href: "#",
                            tabindex: "-1",
                            "aria-selected": (
                              _vm.page === "subscriptions"
                            ).toString(),
                            "aria-controls": "subscriptions"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setPage("subscriptions")
                            }
                          }
                        },
                        [_vm._v("Subscription Orders")]
                      )
                    ]),
                    _c("li", { attrs: { role: "presentation" } }, [
                      _c(
                        "a",
                        {
                          class: _vm.page == "logout" && "active",
                          attrs: { href: "#", tabindex: "0" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setPage("logout")
                            }
                          }
                        },
                        [_vm._v("Logout")]
                      )
                    ])
                  ]
                )
              ]),
              _c(
                "div",
                [
                  _vm.page === "profile"
                    ? _c("profile", {
                        ref: "page",
                        attrs: { id: "profile", role: "tabpanel" }
                      })
                    : _vm._e(),
                  _vm.page === "addresses"
                    ? _c("addresses", {
                        ref: "page",
                        attrs: { id: "addresses", role: "tabpanel" }
                      })
                    : _vm._e(),
                  _vm.page === "notification_preferences"
                    ? _c("notification-preferences", {
                        ref: "page",
                        attrs: {
                          id: "notification_preferences",
                          role: "tabpanel"
                        }
                      })
                    : _vm._e(),
                  _vm.page === "orders"
                    ? _c("orders", {
                        ref: "page",
                        attrs: { id: "orders", role: "tabpanel" }
                      })
                    : _vm._e(),
                  _vm.page === "subscriptions"
                    ? _c("subscriptions", {
                        ref: "page",
                        attrs: { id: "subscriptions", role: "tabpanel" }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }